import { render, staticRenderFns } from "./CrmNote.vue?vue&type=template&id=52697862&scoped=true&"
import script from "./CrmNote.vue?vue&type=script&lang=js&"
export * from "./CrmNote.vue?vue&type=script&lang=js&"
import style0 from "./CrmNote.vue?vue&type=style&index=0&id=52697862&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52697862",
  null
  
)

export default component.exports